import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { profileActions } from 'srcReact/MyProfile/action'
import Button from 'srcReact/components/common2/Button'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Modal from 'srcReact/components/common2/Modal'
import Pill from 'srcReact/components/common2/Pill'
import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'

function ConfirmUpdateUserInterest({ isModalOpen, closeModal, selectedInterest, callbackSuccess }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    myProfile: {
      userInterests: { loading, updated, error }
    }
  } = useSelector((state) => state)

  const [addClicked, setAddClicked] = useState(false)
  const [interestError, setInterestError] = useState('')
  const addInterest = (id) => {
    setAddClicked(true)
    dispatch(profileActions.addInterest(id))
  }
  const removeInterest = (id) => {
    setAddClicked(true)
    dispatch(profileActions.removeInterests(id))
  }

  useEffect(() => {
    if (!loading) {
      if (updated && addClicked) {
        if (callbackSuccess) {
          callbackSuccess(selectedInterest)
        }
        setAddClicked(false)
        setInterestError('')
        closeModal()
      }
      if (!updated && error) {
        setInterestError(error)
      }
    }
    return () => {
      dispatch(profileActions.clearInterestUpdate())
    }
  }, [updated, error, loading])
  return (
    <Modal
      isOpen={isModalOpen}
      title={
        selectedInterest.selected ? t('widgets.interest.removeInterestTitle') : t('widgets.interest.addInterestTitle')
      }
      handleClose={closeModal}>
      <Pill text={selectedInterest.name} selected={selectedInterest.selected} />
      <div className={styles.buttons}>
        <Button style='secondary' text={t('global.cancel')} handleClick={closeModal} />
        <Button
          text={selectedInterest.selected ? t('global.remove') : t('global.add')}
          handleClick={() =>
            selectedInterest.selected ? removeInterest(selectedInterest.id) : addInterest(selectedInterest.id)
          }
        />
        {loading && <Spinner />}
      </div>

      {interestError && <ErrorMessage className={styles.error} text={interestError} />}
    </Modal>
  )
}

export default ConfirmUpdateUserInterest
